import { UsersRepo } from '../../users/users.repo';

class TermsConditions {

  /** @ngInject */
  constructor(private $mdDialog: angular.material.IDialogService, private usersRepo : UsersRepo, private $window: angular.IWindowService) {

  }

  accept(){
    // make call to accept the terms and conditions
    this.usersRepo.acceptTermsConditions()
    .then(res => {
      if(res.data == true){
        this.$mdDialog.hide(true);
      }
    })
  }

  cancel() {
    this.$mdDialog.hide(false);
  }

  openTermsConditions(){
    this.usersRepo.getTermsAndConditions()
    .then(res => {
      let terms = res.data as any;
      this.$window.open(terms.url, '_blank');
    })
  }
}

export const termsConditions: angular.IComponentOptions = {
  template: require('./termsConditions.dialog.html'),
  controller: TermsConditions
}



// WEBPACK FOOTER //
// ./src/app/common/terms-conditions/termsConditions.dialog.ts